/* eslint-disable react/jsx-tag-spacing */ /* for minified SVGs */
import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

enum CaretV2Title {
  up = 'UpCaret',
  right = 'RightCaret',
  down = 'DownCaret',
  left = 'LeftCaret',
  default = 'Caret',
}

export const CaretV2Icon = ({ ...props }: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent
    title={props.direction ? CaretV2Title[props.direction] : CaretV2Title.default}
    viewBox="0 0 14 8"
    {...props}
  >
    {/* prettier-ignore */}
    <path fillRule="evenodd" clipRule="evenodd" d="M6.285 7.701a1.027 1.027 0 001.459-.01l5.937-5.919A1.02 1.02 0 0014 1.034 1.028 1.028 0 0012.257.3l-.003-.004-5.226 5.19L1.764.301 1.76.305A1.028 1.028 0 000 1.027c0 .298.13.561.333.748l5.95 5.93.002-.004z" />
  </CreateIconComponent>
);

export default CaretV2Icon;
